export default {
  voice: '语音任务',
  image: '图片任务',
  text: '文本任务',
  video: '视频任务',
  voiceCut: '语音切割',
  voiceCutNote: '按要求从长音频中截取音频段',
  voiceTags: '语音标注',
  voiceTagsNote: '按要求对音频进行标注',
  voiceEdit: '语音转写',
  voiceEditNote: '将听到的音频转写为文字',
  imageWhole: '整图识别',
  imageWholeNote: '整图识别',
  imageRule: '规则图形标注',
  imageRuleNote: '使用规则图形（矩形，圆等）在图中进行标注',
  imageIrregular: '不规则图形标注',
  imageIrregularNote: '使用不规则图形（多边形，描点等）在图中进行标注',
  imageSimpleRect: '简单拉框任务',
  imageSimpleRectNote: '仅拉框的任务（可通过颜色区分类别）',
  textTranslate: '文本翻译',
  textTranslateNote: '将一种语言翻译为另一种',
  textCouplet: '对句',
  textCoupletNote: '构建一问一答的对话',
  textTags: '分词标注',
  textTagsNote: '语句分词及词性标注',
  textAnalysis: '文本标注',
  textAnalysisNote: '对文本进行词性、专有名词、修饰关系等标注',
  creatBtn: '创建任务',
  taskImg: '预览模板',
  contact: '任务正在开发中，如有需要请联系我们',
  mail: '邮箱：fanhan@fanhantech.com',
  phone: '电话：0086512-6813-8573',
  js: {
    contact: '<p>任务正在开发中，如有需要请联系我们</p><p>邮箱：fanhan@fanhantech.com</p><p>电话：0086512-6813-8573</p>',
    developing: '任务--正在开发中',
    template: '模板',
    please: '请输入任务名称',
    creating: '您正在创建任务--',
    true: '确定',
    cancel: '取消',
    validator: '只能填写汉字、数字、字母、空格及下划线',
    successNote: '新建任务成功',
    cancelNote: '取消输入'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/selectProjectType.js